import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import api_call from '../../globals/common_utilities/axios';
import CONSTANTS from '../../globals/common_utilities/constant';

const initialState = {
	loading: false,
	Response: [],
	error: '',
};

export const Redux_training_centre_list = createAsyncThunk(
	'trainingCenter/Redux_training_centre_list',
	({ token }) => {
		console.log('payload', token);
		return api_call(
			CONSTANTS.API_METHODS.GET,
			'https://cta472fzih.execute-api.ap-south-1.amazonaws.com/dev/api/v1/allstudios',
			{},
			{}
		);
	}
);

const trainingCenter = createSlice({
	name: 'trainingCenter',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(Redux_training_centre_list.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(Redux_training_centre_list.fulfilled, (state, action) => {
			state.loading = false;
			state.Response = action.payload;
			state.error = '';
		});
		builder.addCase(Redux_training_centre_list.rejected, (state, action) => {
			state.loading = false;
			state.Response = [];
			state.error = action.error.message;
		});
	},
});

export const Redux_location = createAsyncThunk(
	'location_list/Redux_location',
	({ token }) => {
		console.log('payload', token);
		return api_call(
			CONSTANTS.API_METHODS.GET,
			'https://cta472fzih.execute-api.ap-south-1.amazonaws.com/dev/api/v1/locations',
			{},
			{}
		);
	}
);

const location_list = createSlice({
	name: 'location_list',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(Redux_location.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(Redux_location.fulfilled, (state, action) => {
			state.loading = false;
			state.Response = action.payload;
			state.error = '';
		});
		builder.addCase(Redux_location.rejected, (state, action) => {
			state.loading = false;
			state.Response = [];
			state.error = action.error.message;
		});
	},
});

export const Redux_primary_aws = createAsyncThunk(
	'primary_aws/Redux_primary_aws',
	({ token }) => {
		console.log('payload', token);
		return api_call(
			CONSTANTS.API_METHODS.GET,
			'https://cta472fzih.execute-api.ap-south-1.amazonaws.com/dev/api/v1/region',
			{},
			{}
		);
	}
);

const primary_aws = createSlice({
	name: 'primary_aws',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(Redux_primary_aws.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(Redux_primary_aws.fulfilled, (state, action) => {
			state.loading = false;
			state.Response = action.payload;
			state.error = '';
		});
		builder.addCase(Redux_primary_aws.rejected, (state, action) => {
			state.loading = false;
			state.Response = [];
			state.error = action.error.message;
		});
	},
});

export const Redux_add_training_center = createAsyncThunk(
	'add_training_center/Redux_add_training_center',
	({ token, body }) => {
		console.log('payload', token);
		return api_call(
			CONSTANTS.API_METHODS.POST,
			'https://cta472fzih.execute-api.ap-south-1.amazonaws.com/dev/api/v1/studios',
			{},
			{},
			body
		);
	}
);

const add_training_center = createSlice({
	name: 'add_training_center',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(Redux_add_training_center.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(Redux_add_training_center.fulfilled, (state, action) => {
			state.loading = false;
			state.Response = action.payload;
			state.error = '';
		});
		builder.addCase(Redux_add_training_center.rejected, (state, action) => {
			state.loading = false;
			state.Response = [];
			state.error = action.error.message;
		});
	},
});

export const instructor_reducer = {
	location_list: location_list.reducer,
	training_center_list: trainingCenter.reducer,
	primary_aws: primary_aws.reducer,
	add_training_center: add_training_center.reducer,
};
